import { render, staticRenderFns } from "./SpaymentreceiptsView.vue?vue&type=template&id=4c9d7597&scoped=true"
import script from "./SpaymentreceiptsView.vue?vue&type=script&lang=js"
export * from "./SpaymentreceiptsView.vue?vue&type=script&lang=js"
import style0 from "./SpaymentreceiptsView.vue?vue&type=style&index=0&id=4c9d7597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d7597",
  null
  
)

export default component.exports